export default __webpack_public_path__ + "static/media/dazai.d42ac4bb.png";